module.exports = __webpack_public_path__ + "img/pr-9.3ee095aa.png";